module.exports = __webpack_public_path__ + "img/exit-screening.0a0175e6.png";